import { render, staticRenderFns } from "./HeadCompanyShow.vue?vue&type=template&id=0d33ebda&scoped=true"
import script from "./HeadCompanyShow.vue?vue&type=script&lang=js"
export * from "./HeadCompanyShow.vue?vue&type=script&lang=js"
import style0 from "./HeadCompanyShow.vue?vue&type=style&index=0&id=0d33ebda&prod&lang=less"
import style1 from "./HeadCompanyShow.vue?vue&type=style&index=1&id=0d33ebda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d33ebda",
  null
  
)

export default component.exports